import request from '@/plugin/axios'

export function ViewUser () {
  return request({
    url: '/user/view',
    method: 'get'
  })
}

export function UploadPortrait (id, data) {
  return request({
    url: '/user/upload?id=' + id,
    method: 'post',
    data
  })
}
